import { render, staticRenderFns } from "./sidebar-menu.vue?vue&type=template&id=11c3d0b2&scoped=true&"
import script from "./sidebar-menu.vue?vue&type=script&lang=ts&"
export * from "./sidebar-menu.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-menu.vue?vue&type=style&index=0&id=11c3d0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3d0b2",
  null
  
)

export default component.exports